import React from 'react';
import Header from '../header';
import Shop from '../shop';
import Cart from '../cart';
import { withDataPhone } from '../hoc';
import { Route } from 'react-router-dom';
import PhoneSingle from '../page/phone-single';

const App = ({ phoneservice }) => {
  return (
    <div>
      <Header />
      <Route
        exact
        path="/re-store"
        render={({ history }) => {
          return (
            <div>
              <Shop data={phoneservice.getList()} />
            </div>
          );
        }}
      />

      <Route
        exact
        path="/re-store/shop/product/:id"
        render={({ match, history }) => {
          let { id } = match.params;
          return <PhoneSingle id={id} history={history} />;
        }}
      />
      <Route path="/re-store/cart" component={Cart} />
    </div>
  );
};

export default withDataPhone()(App);
